export const STATUS_PATH = "/status";

const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

const SERVICE_URLS = {
  development: {
    widget: "https://dev-greenback-app-chat.azurewebsites.net",
    cms: "https://dev-greenback-app-tenants.azurewebsites.net",
    analytics: "https://dev-greenback-app-analytics-subscriber.azurewebsites.net",
    importer: "https://dev-greenback-app-importer.azurewebsites.net",
    webscraper: "https://dev-greenback-app-webscrape.azurewebsites.net",
    gateway: null,
  },
  production: {
    widget: "https://prod-greenback-app-chat.azurewebsites.net",
    cms: "https://prod-greenback-app-cms-gateway.azurewebsites.net/cms",
    // Route Analytics through the CMS gateway in production so the browser uses
    // the same allowed origin as the other production status endpoints.
    analytics: "https://prod-greenback-app-cms-gateway.azurewebsites.net/analytics",
    importer: "https://prod-greenback-app-importer.azurewebsites.net",
    webscraper: "https://prod-greenback-app-webscrape.azurewebsites.net",
    gateway: "https://prod-greenback-app-cms-gateway.azurewebsites.net",
  },
  staging: {
    widget: "https://prod-greenback-app-chat-preview.azurewebsites.net",
    cms: "https://prod-greenback-app-cms-gateway-preview.azurewebsites.net/cms",
    analytics: "https://prod-greenback-app-analytics-preview.azurewebsites.net",
    importer: "https://prod-greenback-app-importer-preview.azurewebsites.net",
    webscraper: "https://prod-greenback-app-webscrape-preview.azurewebsites.net",
    gateway: "https://prod-greenback-app-cms-gateway-preview.azurewebsites.net",
  },
};

const detectEnvironment = () => {
  const reference =
    process.env.REACT_APP_CMS_API_URL ||
    (typeof window !== "undefined" ? window.location.href : "") ||
    "";

  // Staging hosts are prod hosts suffixed with `-preview`, so check preview first.
  if (reference.includes("preview")) return "staging";
  if (reference.includes("prod")) return "production";
  return "development";
};

const ACTIVE_ENV = detectEnvironment();
const ACTIVE_URLS = SERVICE_URLS[ACTIVE_ENV] || SERVICE_URLS.development;

export const DEPENDENCY_LABELS = {
  blobstorage: "Blob",
  cosmos: "Cosmos",
  elasticsearch: "Elasticsearch",
  redis: "Redis",
  servicebus: "Service Bus",
};

export const prettifyDependencyName = (name = "") => {
  if (!name) return "Unknown";
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const dependencyLabel = (name) =>
  DEPENDENCY_LABELS[name] || prettifyDependencyName(name);

const SERVICE_DEFINITIONS = [
  {
    key: "cms",
    name: "Api.Cms",
    baseUrl: ACTIVE_URLS.cms,
    expectedDependencies: [
      "cosmos",
      "redis",
      "elasticsearch",
      "blobstorage",
      "servicebus",
    ],
  },
  {
    key: "widget",
    name: "Api.Widget",
    baseUrl: ACTIVE_URLS.widget,
    expectedDependencies: [
      "cosmos",
      "redis",
      "elasticsearch",
      "blobstorage",
      "servicebus",
    ],
  },
  {
    key: "analytics",
    name: "Api.Analytics",
    baseUrl: ACTIVE_URLS.analytics,
    expectedDependencies: ["cosmos", "redis", "elasticsearch", "servicebus"],
    note: "FastEndpoint",
  },
  {
    key: "importer",
    name: "Importer.Api",
    baseUrl: ACTIVE_URLS.importer,
    expectedDependencies: ["cosmos", "servicebus"],
  },
  {
    key: "webscraper",
    name: "WebScraper.API",
    baseUrl: ACTIVE_URLS.webscraper,
    expectedDependencies: ["cosmos", "servicebus"],
  },
  {
    key: "gateway",
    name: "Api.Gateway",
    baseUrl: ACTIVE_URLS.gateway,
    expectedDependencies: ["redis", "elasticsearch"],
    note: "Middleware checks",
  },
];

export const SERVICES_STATUS_CONFIG = SERVICE_DEFINITIONS.filter(
  (service) => Boolean(service.baseUrl)
).map((service) => ({
  ...service,
  baseUrl: trimTrailingSlash(service.baseUrl),
}));
